import toast from "react-hot-toast";

export const copyToClipboard = (object: string, text: string, objectType: string = "url") => {
  navigator.clipboard.writeText(text);

  // Alert the copied text
  toast.success(`The ${object} ${objectType} has been copied to your clipboard.`);
};
